import UUID from 'uuidjs';
import { ref } from 'vue';

export type AlertMessage = {
  id: string;
  text: string;
};

export const useAlertMessages = () => {
  const alertMessages = ref<AlertMessage[]>([]);

  const clearAlertMessages = (): void => {
    alertMessages.value = [];
  };

  const pushAlertMessage = (text: string): void => {
    alertMessages.value.push({ id: UUID.generate(), text });
  };

  return { alertMessages, clearAlertMessages, pushAlertMessage };
};
